import { useSelector } from 'react-redux';
import { setMyData } from '../../store';
import '../css/app.css'
import '../css/main.css'
import '../css/common.css'
import '../css/payment.css'
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom"
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import { LogOut, KeyRound, LayoutDashboard, Users, NotebookPen, CreditCard, PhoneCall } from 'lucide-react';
import useWindowSize from '../hook/useWindowSize';

function Header() {
    let location = useLocation();
    let navigate = useNavigate();

    const HeaderTitle = useSelector((state) => { return state.HeaderTitle })
    const hostLogoImg = useSelector((state) => state.hostLogoImg.value);
    const Current_Location = useSelector((state) => { return state.Current_Location.value });
    const MyData = useSelector((state) => state.MyData);

    const [hamBtn, setHamBnt] = useState(false)
    const [logoutBtn, setLogoutBtn] = useState(false)
    const [message, setMessage] = useState("")
    const [passwordModal, setPasswordModal] = useState(false)
    const [pinModal, setPinModal] = useState(false)
    const [payPasswordModal, setPayPasswordModal] = useState(false)

    const onSubmit = async () => {
        if (window.confirm("로그아웃을 하시겠습니까?")) {
            await axios.post(process.env.REACT_APP_API + "/api/user/logout", {
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setLogoutBtn(false)
                    setHamBnt(false)
                    navigate('/')
                }
                else {
                    setMessage({ msg: "로그아웃에 실패했습니다." })
                }
            }).catch(error => {
                console.error(error);
                setMessage({ msg: "로그아웃 처리 중 오류가 발생했습니다." });
            });
        }
    }

    const ResponsiveImage = ({ smallSrc, largeSrc, alt, breakpoint = 1280 }) => {
        const [windowWidth, setWindowWidth] = useState(window.innerWidth);

        useEffect(() => {
            const handleResize = () => setWindowWidth(window.innerWidth);
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        const imageSrc = windowWidth <= breakpoint ? smallSrc : largeSrc;

        return <img src={imageSrc} alt={alt} className={windowWidth <= breakpoint ? "w-8" : "w-32"} />;
    };

    const PasswordModalClose = () => {
        setPasswordModal(false)
        // setHamBnt(false)
        setLogoutBtn(false)
    }

    const PinModalClose = () => {
        setPinModal(false)
        setLogoutBtn(false)
    }

    const PayPasswordModalClose = () => {
        setPayPasswordModal(false)
        setLogoutBtn(false)
    }


    const [btn, setBtn] = useState([false, false, false, false, false, false]);

    const onClickBtn = (idx) => {
        let arr = [false, false, false, false, false, false];
        for (let i = 0; i < arr.length; i++) {
            if (i === idx) {
                arr[i] = !btn[i];
            } else {
                arr[i] = false;
            }
        }
        setBtn(arr);
    };

    return (
        <div style={{
            display: location.pathname == '/'
                || location.pathname == '/createMerchantsAgent'
                || location.pathname == '/urlComplete'
                || location.pathname == '/urlNotice'
                || location.pathname == '/sms'
                || location.pathname == '/smsa'
                || location.pathname.startsWith('/urlPayment/sms')
                ? "none" : ""
        }}>
            <MessageModal message={message} />
            {passwordModal ? <ChangePassword setModal={PasswordModalClose} setMessage={setMessage} /> : ""}
            {pinModal ? <ChangePin setModal={PinModalClose} setMessage={setMessage} /> : ""}
            {payPasswordModal ? <ChangePayPassword setModal={PayPasswordModalClose} setMessage={setMessage} /> : ""}
            <div className={`mobile-menu md:hidden ${hamBtn ? "mobile-menu--active" : ""}`}>
                <div className="mobile-menu-bar" style={{ position: "relative" }}>
                    <Link to={`/dashboard`} className="main_logo flex mr-auto gnb-link">
                        {
                            hostLogoImg == "onu"
                                ?
                                <ResponsiveImage
                                    smallSrc="/img/ong.jpg"
                                    largeSrc="/img/ong.jpg"
                                    alt="East Commerce Logo"
                                    breakpoint={768}
                                />
                                : hostLogoImg == "baekma"
                                ?
                                <ResponsiveImage
                                    smallSrc="/img/wh_logo_white.png"
                                    largeSrc="/img/wh_logo_white.png"
                                    alt="Inbiz Logo"
                                    breakpoint={768}
                                />
                                :
                                <ResponsiveImage
                                    smallSrc="/img/dl_symbol.png"
                                    largeSrc="/img/dl_logo_white.png"
                                    alt="East Commerce Logo"
                                    breakpoint={1280}
                                />
                        }
                    </Link>

                    {/* <ul className="header_gnb">
                        {
                            JSON.parse(localStorage.getItem("userId"))?.sugi_expose == "Y"
                                ?
                                <li>
                                    <Link
                                        to={`/sugi`}
                                        className="gnb-link"
                                        onClick={() => setHamBnt(false)}
                                    >
                                        수기
                                    </Link>
                                </li>
                                :
                                ""
                        }
                        <li>
                            <Link
                                to={`/paylist`}
                                className="gnb-link"
                                onClick={() => setHamBnt(false)}
                            >
                                거래
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`/settlement`}
                                className="gnb-link"
                                onClick={() => setHamBnt(false)}
                            >
                                정산
                            </Link>
                        </li>
                    </ul> */}

                    <div style={{ position: "absolute", top: "50%", left: "50%", transform: 'translate(-50%, -50%)', color: "#fff", fontSize: "16px" }}>{Current_Location}</div>

                    <div className="mobile-menu-wrap">
                        <a href="javascript:;" className={`mobile-menu-toggler  ${hamBtn ? "mobile-menu--active" : ""}`} onClick={() => setHamBnt(e => !e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="bar-chart-2" data-lucide="bar-chart-2" className="lucide lucide-bar-chart-2 w-8 h-8 text-white transform -rotate-90"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
                        </a>
                        {
                            hamBtn
                                ?
                                <div className="scrollable">
                                    <div className="menu_wrap">
                                        <div className="user_info_wrap">
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <div className="user_detail">
                                                    <span className="user_authority">관리자</span>
                                                </div>
                                                <div style={{ display: "flex", gap: "8px" }}>
                                                    <div
                                                        className="user_detail"
                                                        onClick={() => {
                                                            setPasswordModal(true);
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <span className="user_organization">비밀번호 변경</span>
                                                    </div>
                                                    <div
                                                        className="user_detail"
                                                        onClick={() => {
                                                            setPinModal(true);
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <span className="user_organization">PIN 변경</span>
                                                    </div>
                                                                                                        <div
                                                        className="user_detail"
                                                        onClick={() => {
                                                            setPayPasswordModal(true);
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <span className="user_organization">결제비밀번호 변경</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="user_greeting">
                                                <p className="user_name">{MyData.co_nm || "가맹점"}</p>
                                                <p>님 반갑습니다.</p>
                                            </div>
                                        </div>

                                        <hr className="separation_line" />

                                        <ul className="scrollable__content py-2">
                                            <li>
                                                <Link
                                                    to={"/dashboard"}
                                                    className="menu"
                                                    onClick={() => setHamBnt(false)}
                                                >
                                                    <div className="menu__icon">
                                                        <LayoutDashboard />
                                                    </div>
                                                    <div className="menu__title">대시보드</div>
                                                </Link>
                                            </li>
                                            {
                                                JSON.parse(localStorage.getItem("userId"))?.sugi_expose == "Y"
                                                    ?
                                                    <li>
                                                        <Link
                                                            to={"/sugi"}
                                                            className="menu"
                                                            onClick={() => setHamBnt(false)}
                                                        >
                                                            <div className="menu__icon">
                                                                <CreditCard />
                                                            </div>
                                                            <div className="menu__title">수기결제</div>
                                                        </Link>
                                                    </li>
                                                    :
                                                    ""
                                            }
                                            <li>
                                                <Link
                                                    to={"/paylist"}
                                                    className="menu"
                                                    onClick={() => setHamBnt(false)}
                                                >
                                                    <div className="menu__icon">
                                                        <NotebookPen />
                                                    </div>
                                                    <div className="menu__title">거래조회</div>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to={"/settlement"}
                                                    className="menu"
                                                    onClick={() => setHamBnt(false)}
                                                >
                                                    <div className="menu__icon">
                                                        <NotebookPen />
                                                    </div>
                                                    <div className="menu__title">정산내역</div>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to={"/withdraw"}
                                                    className="menu"
                                                    onClick={() => setHamBnt(false)}
                                                >
                                                    <div className="menu__icon">
                                                        <NotebookPen />
                                                    </div>
                                                    <div className="menu__title">입출금내역</div>
                                                </Link>
                                            </li>
                                            {
                                                JSON.parse(localStorage.getItem("userId"))?.urlpay == 1
                                                    ?
                                                    <li>
                                                        <Link className="menu" onClick={() => onClickBtn(0)}>
                                                            <div className="menu__icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-link-icon lucide-link"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>
                                                            </div>
                                                            <div className="menu__title">
                                                                URL결제
                                                                <i
                                                                    className={`menu__sub-icon ${btn[0] ? "transform rotate-180" : ""}`}
                                                                ></i>
                                                            </div>
                                                        </Link>
                                                        {btn[0] && (
                                                            <ul className="depth_2">
                                                                <li>
                                                                    <Link
                                                                        to={"/urlCreate"}
                                                                        className="menu side_gnb"
                                                                        data-id="admin"
                                                                        onClick={() => setHamBnt(false)}
                                                                    >
                                                                        <div className="menu__title">URL상품관리</div>
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link
                                                                        to={"/urlHistory"}
                                                                        className="menu side_gnb"
                                                                        data-id="admin"
                                                                        onClick={() => setHamBnt(false)}
                                                                    >
                                                                        <div className="menu__title">URL상품결제내역</div>
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        )}
                                                    </li>
                                                    :
                                                    ""
                                            }
                                            {
                                                JSON.parse(localStorage.getItem("userId"))?.smsKYC == 1
                                                    ?
                                                    <li>
                                                        <Link
                                                            to={"/smsPayment"}
                                                            className="menu"
                                                            onClick={() => setHamBnt(false)}
                                                        >
                                                            <div className="menu__icon">
                                                                <PhoneCall />
                                                            </div>
                                                            <div className="menu__title">SMS수기결제</div>
                                                        </Link>
                                                    </li>
                                                    :
                                                    ""
                                            }
                                            {
                                                JSON.parse(localStorage.getItem("userId"))?.smsConfirm == 1
                                                    ?
                                                    <li>
                                                        <Link
                                                            to={"/smsAuthPayment"}
                                                            className="menu"
                                                            onClick={() => setHamBnt(false)}
                                                        >
                                                            <div className="menu__icon">
                                                                <PhoneCall />
                                                            </div>
                                                            <div className="menu__title">SMS인증결제</div>
                                                        </Link>
                                                    </li>
                                                    :
                                                    ""
                                            }
                                        </ul>
                                    </div>
                                    <div className="logout-btn">
                                        <Link id="logout-admin" onClick={() => onSubmit()}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24" height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                icon-name="power"
                                                data-lucide="power"
                                                className="lucide lucide-power"
                                            >
                                                <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
                                                <line x1="12" y1="2" x2="12" y2="12"></line>
                                            </svg>
                                            <span>로그아웃</span>
                                        </Link>
                                    </div>
                                </div>
                                :
                                ""
                        }
                    </div>
                </div>
            </div>
            <div className="top-bar-boxed h-[70px] md:h-[65px] z-[51] border-b border-white/[0.08] mt-12 md:mt-0 -mx-3 sm:-mx-8 md:-mx-0 px-3 md:border-b-0 relative md:fixed md:inset-x-0 md:top-0 md:px-8 md:bg-gradient-to-b md:from-slate-100 md:to-transparent dark:md:from-darkmode-700" style={{ maxWidth: "1920px", margin: "0 auto" }}>
                <div className="h-full flex items-center -intro-x h-[45px]" style={{ float: "left" }}>
                    {/* <a href="" className="logo -intro-x hidden md:flex  xl:w-[180px] xl:mr-0 mr-5 block" style={{ left: "20px" }}>
                        <img alt="ant" className="logo__image w-32" src="/img/dl_logo_white.png" />
                    </a> */}
                    <Link to={`/dashboard`} className="main_logo flex mr-auto gnb-link">
                        {
                            hostLogoImg == "onu"
                                ?
                                <ResponsiveImage
                                    smallSrc="/img/ong.jpg"
                                    largeSrc="/img/ong.jpg"
                                    alt="East Commerce Logo"
                                    breakpoint={768}
                                />
                                : hostLogoImg == "baekma"
                                ?
                                <ResponsiveImage
                                    smallSrc="/img/wh_logo_white.png"
                                    largeSrc="/img/wh_logo_white.png"
                                    alt="Inbiz Logo"
                                    breakpoint={768}
                                />
                                :
                                <ResponsiveImage
                                    smallSrc="/img/dl_symbol.png"
                                    largeSrc="/img/dl_logo_white.png"
                                    alt="East Commerce Logo"
                                    breakpoint={1280}
                                />
                        }
                    </Link>
                    <nav aria-label="breadcrumb" className="-intro-x h-[45px] mr-auto">
                        <ol className="breadcrumb breadcrumb-light">
                            <li className="breadcrumb-item pg_title" id="pg_title" value="">{HeaderTitle?.mainTitle ?? ""}</li>
                        </ol>
                    </nav>
                </div>
                <div className="" style={{ float: "right" }}>
                    <div className="h-full flex items-center intro-x h-[45px] mr-5" style={{ float: "left" }}>
                        <span style={{ color: "white" }}>{MyData.co_nm || ""} 님</span>
                    </div>
                    <div className="intro-x dropdown w-8 h-[45px] flex items-center dropdown_user" style={{ float: "left" }}>
                        <div className="dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in scale-110" role="button" aria-expanded="false" data-tw-toggle="dropdown">
                            <img id="user-info-toggle" alt="Midone - HTML Admin Template" src="/img/profile-6.jpg" onClick={() => setLogoutBtn(e => !e)} />
                        </div>
                        {
                            logoutBtn
                                ?
                                <div className="dropdown-user-info w-56">
                                    <ul className="dropdown-content bg-primary/80 before:block before:absolute before:bg-black before:inset-0 before:rounded-md before:z-[-1] text-white">
                                        <li className="p-2">
                                            <div className="font-medium">{MyData.co_nm || ""}</div>
                                            <div className="text-xs text-white/60 mt-0.5 dark:text-slate-500">가맹점</div>
                                        </li>
                                        <li>
                                            <hr className="dropdown-divider border-white/[0.08]" />
                                        </li>
                                        <li>
                                            <hr className="dropdown-divider border-white/[0.08]" />
                                        </li>
                                        <li>
                                            <Link id="logout-user" className="dropdown-item hover:bg-white/5" data-kind="pc" onClick={() => setPasswordModal(e => !e)}>
                                                <KeyRound style={{ width: "15px", marginRight: "8px" }} />
                                                <div>비밀번호변경</div>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item hover:bg-white/5" data-kind="pc" onClick={() => setPinModal(e => !e)}>
                                                <KeyRound style={{ width: "15px", marginRight: "8px" }} />
                                                <div>PIN변경</div>
                                            </Link>
                                        </li>
                                                                                <li>
                                            <Link className="dropdown-item hover:bg-white/5" data-kind="pc" onClick={() => setPayPasswordModal(e => !e)}>
                                                <KeyRound style={{ width: "15px", marginRight: "8px" }} />
                                                <div>결제비밀번호 변경</div>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link id="logout-user" className="dropdown-item hover:bg-white/5" data-kind="pc" onClick={() => onSubmit()}>
                                                <LogOut style={{ width: "15px", marginRight: "8px" }} />
                                                <div>로그아웃</div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                :
                                ""
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function ChangePassword({ setModal, setMessage }) {
    const [formData, setFormData] = useState({
        ID: JSON.parse(localStorage.getItem("userId"))?.mid ?? "",
        currentPw: '',
        newPw: '',
        newPwConfirm: '',
    });

    // input onChange 핸들러 (필드명(name)에 따라 업데이트)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const onSubmit = async () => {
        if (!formData.currentPw) {
            setMessage({ msg: "현재 비밀번호를 입력하세요." });
            return;
        }
        if (formData.newPw.length < 8) {
            setMessage({ msg: "새 비밀번호는 8자 이상이어야 합니다." });
            return;
        }
        if (!/[A-Za-z]/.test(formData.newPw) || !/[0-9]/.test(formData.newPw)) {
            setMessage({ msg: "새 비밀번호는 영문과 숫자를 포함해야 합니다." });
            return;
        }
        if (formData.newPw !== formData.newPwConfirm) {
            setMessage({ msg: "새 비밀번호가 일치하지 않습니다." });
            return;
        }
        await axios.post(process.env.REACT_APP_API + "/api/user/change-password", {
            currentPassword: formData.currentPw,
            newPassword: formData.newPw,
            confirmPassword: formData.newPwConfirm,
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setMessage({ msg: "비밀번호변경 성공" })
                setModal()
            }
            else {
                setMessage({ msg: "비밀번호변경 실패" })
            }
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "비밀번호 변경 중 오류가 발생했습니다." });
        });
    }

    return (
        <div id="admin-modal" className="modal show_modal" tabIndex="-1">
            <input type="hidden" id="event_check" value="update" />
            <div className="modal-dialog">
                <div className="modal-content marginTop30 admin-modal-sty">
                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                            padding: "0px",
                            borderBottom: "1px solid #E5E5E5",
                            backgroundColor: "#fff",
                        }}
                    >
                        <button
                            className="tab-btn active"
                            style={{
                                padding: "12px 10px 8px",
                                fontSize: "17px",
                                fontWeight: "600",
                                color: "#222",
                                background: "transparent",
                                border: "none",
                                borderBottom: "3px solid #3182F6",
                                transition: "all 0.2s ease-in-out",
                                cursor: "pointer",
                            }}
                        >
                            비밀번호 변경
                        </button>
                    </div>

                    {/* form 태그 */}
                    <form
                        id="modal-form"
                        className="modal-body grid grid-cols-12 gap-4 gap-y-3"
                        onSubmit={(e) => e.preventDefault()}
                        style={{ padding: "15px 0" }}
                    >
                        <div className="col-span-12">
                            <label className="form-label">ID</label>
                            <input
                                id="ID"
                                name="ID"
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={formData.ID}
                                disabled
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="currentPw" className="form-label">
                                현재 비밀번호
                            </label>
                            <input
                                id="currentPw"
                                name="currentPw"
                                type="password"
                                className="form-control"
                                placeholder=""
                                value={formData.currentPw}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="newPw" className="form-label">
                                새 비밀번호
                            </label>
                            <input
                                id="newPw"
                                name="newPw"
                                type="password"
                                className="form-control"
                                placeholder=""
                                value={formData.newPw}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="newPwConfirm" className="form-label">
                                새 비밀번호 확인
                            </label>
                            <input
                                id="newPwConfirm"
                                name="newPwConfirm"
                                type="password"
                                autoComplete="off"
                                className="form-control"
                                placeholder=""
                                value={formData.newPwConfirm}
                                onChange={handleChange}
                            />
                        </div>
                    </form>

                    <div className="modal-footer">
                        <button
                            id="signup-btn"
                            type="submit"
                            className="btn btn-primary"
                            onClick={onSubmit}
                        >
                            등록
                        </button>
                        <button
                            type="button"
                            data-tw-dismiss="modal"
                            className="btn btn-outline-secondary mr-1 admin-modal-btn"
                            onClick={() => setModal()}
                        >
                            닫기
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function ChangePin({ setModal, setMessage }) {
    const [formData, setFormData] = useState({
        currentPin: '',
        newPin: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        // 숫자만 허용, 4자리 제한
        const numericValue = value.replace(/[^0-9]/g, '').slice(0, 4);
        setFormData((prev) => ({
            ...prev,
            [name]: numericValue,
        }));
    };

    const onSubmit = async () => {
        if (formData.newPin.length !== 4) {
            setMessage({ msg: "PIN 번호는 4자리 숫자를 입력하세요." })
            return
        }
        await axios.post(process.env.REACT_APP_API + "/api/user/change-pin", {
            currentPin: formData.currentPin,
            newPin: formData.newPin,
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code === 1000) {
                setMessage({ msg: "PIN 변경 성공" })
                setModal()
            }
            else if (tmp?.code === 4000) {
                setMessage({ msg: "4자리 숫자를 입력하세요." })
            }
            else if (tmp?.code === 4003) {
                setMessage({ msg: "현재 PIN이 틀립니다." })
            }
            else {
                setMessage({ msg: tmp?.msg || "PIN 변경 실패" })
            }
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "PIN 변경에 실패했습니다." })
        });
    }

    return (
        <div id="admin-modal" className="modal show_modal" tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content marginTop30 admin-modal-sty">
                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                            padding: "0px",
                            borderBottom: "1px solid #E5E5E5",
                            backgroundColor: "#fff",
                        }}
                    >
                        <button
                            className="tab-btn active"
                            style={{
                                padding: "12px 10px 8px",
                                fontSize: "17px",
                                fontWeight: "600",
                                color: "#222",
                                background: "transparent",
                                border: "none",
                                borderBottom: "3px solid #3182F6",
                                transition: "all 0.2s ease-in-out",
                                cursor: "pointer",
                            }}
                        >
                            PIN 변경
                        </button>
                    </div>

                    <form
                        id="modal-form"
                        className="modal-body grid grid-cols-12 gap-4 gap-y-3"
                        onSubmit={(e) => e.preventDefault()}
                        style={{ padding: "15px 0" }}
                    >
                        <div className="col-span-12">
                            <label htmlFor="currentPin" className="form-label">
                                현재 PIN
                            </label>
                            <input
                                id="currentPin"
                                name="currentPin"
                                type="password"
                                inputMode="numeric"
                                maxLength={4}
                                className="form-control"
                                placeholder="4자리 숫자"
                                value={formData.currentPin}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="newPin" className="form-label">
                                새 PIN
                            </label>
                            <input
                                id="newPin"
                                name="newPin"
                                type="password"
                                inputMode="numeric"
                                maxLength={4}
                                className="form-control"
                                placeholder="4자리 숫자"
                                value={formData.newPin}
                                onChange={handleChange}
                            />
                        </div>
                    </form>

                    <div className="modal-footer">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={onSubmit}
                        >
                            변경
                        </button>
                        <button
                            type="button"
                            data-tw-dismiss="modal"
                            className="btn btn-outline-secondary mr-1 admin-modal-btn"
                            onClick={() => setModal()}
                        >
                            닫기
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function ChangePayPassword({ setModal, setMessage }) {
    const [formData, setFormData] = useState({
        currentPayPassword: '',
        newPayPassword: '',
        newPayPasswordConfirm: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/[^0-9]/g, '').slice(0, 6);
        setFormData((prev) => ({
            ...prev,
            [name]: numericValue,
        }));
    };

    const onSubmit = async () => {
        if (formData.newPayPassword.length < 4) {
            setMessage({ msg: "결제비밀번호는 4자리 이상 숫자를 입력하세요." })
            return
        }
        if (formData.newPayPassword !== formData.newPayPasswordConfirm) {
            setMessage({ msg: "새 결제비밀번호가 일치하지 않습니다." })
            return
        }
        await axios.post(process.env.REACT_APP_API + "/api/user/change-pay-password", {
            currentPayPassword: formData.currentPayPassword,
            newPayPassword: formData.newPayPassword,
            confirmPayPassword: formData.newPayPasswordConfirm,
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code === 1000) {
                setMessage({ msg: "결제비밀번호 변경 성공" })
                setModal()
            }
            else if (tmp?.code === 4000) {
                setMessage({ msg: tmp?.msg || "올바른 형식의 비밀번호를 입력하세요." })
            }
            else if (tmp?.code === 4003) {
                setMessage({ msg: "현재 결제비밀번호가 틀립니다." })
            }
            else {
                setMessage({ msg: tmp?.msg || "결제비밀번호 변경 실패" })
            }
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "결제비밀번호 변경에 실패했습니다." })
        });
    }

    return (
        <div id="admin-modal" className="modal show_modal" tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content marginTop30 admin-modal-sty">
                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                            padding: "0px",
                            borderBottom: "1px solid #E5E5E5",
                            backgroundColor: "#fff",
                        }}
                    >
                        <button
                            className="tab-btn active"
                            style={{
                                padding: "12px 10px 8px",
                                fontSize: "17px",
                                fontWeight: "600",
                                color: "#222",
                                background: "transparent",
                                border: "none",
                                borderBottom: "3px solid #3182F6",
                                transition: "all 0.2s ease-in-out",
                                cursor: "pointer",
                            }}
                        >
                            결제비밀번호 변경
                        </button>
                    </div>

                    <form
                        id="modal-form"
                        className="modal-body grid grid-cols-12 gap-4 gap-y-3"
                        onSubmit={(e) => e.preventDefault()}
                        style={{ padding: "15px 0" }}
                    >
                        <div className="col-span-12">
                            <label htmlFor="currentPayPassword" className="form-label">
                                현재 결제비밀번호
                            </label>
                            <input
                                id="currentPayPassword"
                                name="currentPayPassword"
                                type="password"
                                inputMode="numeric"
                                maxLength={6}
                                className="form-control"
                                placeholder="숫자 입력"
                                value={formData.currentPayPassword}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="newPayPassword" className="form-label">
                                새 결제비밀번호
                            </label>
                            <input
                                id="newPayPassword"
                                name="newPayPassword"
                                type="password"
                                inputMode="numeric"
                                maxLength={6}
                                className="form-control"
                                placeholder="숫자 입력"
                                value={formData.newPayPassword}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="newPayPasswordConfirm" className="form-label">
                                새 결제비밀번호 확인
                            </label>
                            <input
                                id="newPayPasswordConfirm"
                                name="newPayPasswordConfirm"
                                type="password"
                                inputMode="numeric"
                                maxLength={6}
                                className="form-control"
                                placeholder="숫자 입력"
                                value={formData.newPayPasswordConfirm}
                                onChange={handleChange}
                            />
                        </div>
                    </form>

                    <div className="modal-footer">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={onSubmit}
                        >
                            변경
                        </button>
                        <button
                            type="button"
                            data-tw-dismiss="modal"
                            className="btn btn-outline-secondary mr-1 admin-modal-btn"
                            onClick={() => setModal()}
                        >
                            닫기
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;